export default {
  news: [],
  active_news: [],
  single_news: [],
};
